const primary = 'indigo'
const primaryHTML = '#1A237E'
const primaryAccent = 'indigo accent-4'
const primaryAccentHTML = '#304FFE'
const secondary = 'blue darken-2'
const secondaryHTML = '#1976D2'
const secondaryAccent = 'blue accent-2'
const secondaryAccentHTML = '#448AFF'
const tertiary = 'indigo darken-2'
const tertiaryHTML = '#303F9F'
const tertiaryAccent = 'indigo accent-2'
const tertiaryAccentHTML = '#536DFE'
const complement = 'orange darken-3'
const complementHTML = '#EF6C00'
const complementAccent = 'orange accent-3'
const complementAccentHTML = '#FF9100'
const warning = 'amber'
const warningHTML = '#FFC107'
const success = 'light-green darken-4'
const successHTML = '#33691E'
const danger = 'red darken-4'
const dangerHTML = '#B71C1C'
const info = 'teal darken-2'
const infoHTML = '#00796B'

export default {
    primary,
    secondary,
    tertiary,
    complement,
    complementAccent,
    warning,
    success,
    primaryAccent,
    secondaryAccent,
    tertiaryAccent,
    primaryHTML,
    secondaryHTML,
    tertiaryHTML,
    complementHTML,
    complementAccentHTML,
    warningHTML,
    successHTML,
    primaryAccentHTML,
    secondaryAccentHTML,
    tertiaryAccentHTML,
    danger,
    dangerHTML,
    info,
    infoHTML,
}
